import { render } from "./StoreProductCollection.vue?vue&type=template&id=5185bd6d&scoped=true"
import script from "./StoreProductCollection.vue?vue&type=script&lang=js"
export * from "./StoreProductCollection.vue?vue&type=script&lang=js"

import "./StoreProductCollection.vue?vue&type=style&index=0&id=5185bd6d&lang=scss&scoped=true"

import exportComponent from "G:\\ElectronicPointOfSales\\Mang.EposApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5185bd6d"]])

export default __exports__